import { Injectable } from '@angular/core';
import { AppConfig } from 'app/config/service.config';
import { BehaviorSubject, Observable } from 'rxjs';

export type Brand = 'e-kedai' | 'bizwallet';

@Injectable({
    providedIn: 'root'
})
export class BrandService {
    private _currentBrand: BehaviorSubject<Brand> = new BehaviorSubject<Brand>('e-kedai');

    constructor() {
        // Initialize from localStorage if exists
        const savedBrand = localStorage.getItem('currentBrand') as Brand;        
        if (savedBrand) {
            this._currentBrand.next(savedBrand);
        }
    }

    get currentBrand$(): Observable<Brand> {
        return this._currentBrand.asObservable();
    }

    get currentBrand(): Brand {
        return this._currentBrand.value;
    }

    setBrand(brand: Brand): void {
        localStorage.setItem('currentBrand', brand);
        this._currentBrand.next(brand);
    }

    getApiEndpoint(apiServer: AppConfig): string {
        
        return this.currentBrand === 'bizwallet' 
            ? apiServer.settings.apiServer.ekedaiBizwalletService
            : apiServer.settings.apiServer.ekedaiService;
    }
}